export var HTMLData_Source;
(function (HTMLData_Source) {
    HTMLData_Source["HTML"] = "HTML";
    HTMLData_Source["ADSENSE"] = "ADSENSE";
    HTMLData_Source["UNRECOGNIZED"] = "UNRECOGNIZED";
})(HTMLData_Source || (HTMLData_Source = {}));
//# sourceMappingURL=plugin_html.enums.js.map